import { Routes } from "@angular/router";
import { AuthGuardFrontUsers } from "../../../shared/services/auth-guard/auth-guard-frontusers.service";
import { AuthGuardLogin } from "../../../shared/services/auth-guard/auth-guard-login.service";
import { BoardingServicesComponent } from "./boarding-services/boarding-services.component";
import { CageDetailsComponent } from "./cage-details/cage-details.component";
import { CageBookingComponent } from "./cage_booking/cage_booking.component";

export const routes: Routes = [
  {
    path: "boarding-service/:id",
    component: BoardingServicesComponent,

    data: {
      urls: [
        {
          title: "Home",
          url: "/",
        },
        {
          title: "Boarding Services",
        },
      ],
    },
  },
  {
    path: "cage_details/:petTypeId/:id",
    component: CageDetailsComponent,
    data: {
      urls: [
        {
          title: "Home",
          url: "/",
        },
        {
          title: "Boarding Services",
          url: "/boarding-service/:id",
        },
        { title: "Cage Details" },
      ],
    },
  },
  {
    path: "cage_booking/:petTypeId/:cageTypeId",
    component: CageBookingComponent,
    data: {
      urls: [
        {
          title: "Home",
          url: "/",
        },
        {
          title: "Boarding Services",
          url: "/boarding-service/:id",
        },
        { title: "Cage Booking" },
      ],
    },
    canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
  },
  {
    path: "saved_cage_booking/:petTypeId/:cageTypeId/:saveBookingId",
    component: CageBookingComponent,
    data: {
      urls: [
        {
          title: "Home",
          url: "/",
        },
        {
          title: "Dashboard",
          url: "/dashboard",
        },
        {
          title: "Saved Booking",
          url: "/saved_bookings",
        },
        { title: "Continue Booking" },
      ],
    },
    canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
  },
];
